exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "calendar-context-menu{position:absolute;display:none;top:0;bottom:0;z-index:1;cursor:pointer;border-radius:1px}calendar-context-menu .arrow-up{width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-bottom:3px solid #0072c9;margin:0 auto}calendar-context-menu .option{width:100px;height:32px;background:#0072c9;text-align:center;color:#fff;font-size:13px;line-height:35px}calendar-context-menu .option.border{border-bottom:1px solid #fff}calendar-context-menu .option:hover{background:#04408f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/calendarContextMenu/calendarContextMenu.scss
// module id = 1461
// module chunks = 0